import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BettingComponent } from './betting.component';

const routes: Routes = [
  {
    path: 'betting',
    component: BettingComponent
  }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class BettingRoutingModule {
}



// WEBPACK FOOTER //
// C:/Users/jenkins/AppData/Local/Jenkins/.jenkins/workspace/keno-web/vit-keno/src/app/betting/betting-routing.module.ts